angular.module('autoremind.communications')
    .directive('communicationsMessageEditor', ['jobService', 'templateService',
    function (jobService, templateService) {
        return {
            restrict: 'E',
            scope: true,
            templateUrl: 'app/communication/forms/communications-message-editor.html',
            link: function (scope, elem, attr) {
                scope.setActiveTabOfMessages = function (event) {
                    templateService.setActiveTabOfMessages(event);
                };
            }
        };
    }]);
//# sourceMappingURL=communications-message-editor.js.map